// Form helpers

import { addClass, getClosesParent, hasClass } from './generic';

/**
 * Nastavi specifickou classu na parent element controlu s chybou
 * @param errorSelector   selector elementu, v ramci ktereho se uprava provede (vetsinou cely formular)
 * @param targetClassName   className elementu, na ktery se nastavi zvolena classa
 * @param errorClassName    className ktera se ma nastavit na cilovy element
 */
export const markInvalidControls = (errorSelector: string, targetClassName: string, errorClassName: string): void => {
    [].forEach.call(document.querySelectorAll(errorSelector), function (errorEl: Node) {
        const targetEl = getClosesParent(errorEl, function (el: HTMLElement) {
            return hasClass(el, targetClassName);
        });
        if (targetEl) {
            addClass(targetEl as Element, errorClassName);
        }
    });
};
